module.exports = __webpack_public_path__ + "static/media/h300_2.3f09791f0180e30b74de900ebc00d506.png";